module.exports = __webpack_public_path__ + "img/b_intro_3_en.fc40c2a.png";